import { render, staticRenderFns } from "./backendLogin.vue?vue&type=template&id=2278173e&scoped=true&"
import script from "./backendLogin.vue?vue&type=script&lang=js&"
export * from "./backendLogin.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/login.less?vue&type=style&index=0&id=2278173e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2278173e",
  null
  
)

component.options.__file = "backendLogin.vue"
export default component.exports